export default __webpack_public_path__ + "static/media/goharzaminLogo.78752758.png";